<ion-header>
    <ion-toolbar>
        <ion-title>{{title}}</ion-title>
        <ion-buttons slot="end">
            <ion-button uppDataid="timemodal-apply-button" [disabled]="!CanApply" (click)="OnApply()">
                <ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
            </ion-button>
            <ion-button uppDataid="timemodal-close-button" (click)="OnClose()">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="time-modal-body">
        <div class="time-columns">
            <div
                class="time-unit"
                (touchstart)="OnTouchStart('hour', $event)"
                (touchmove)="OnTouchMove('hour', $event)"
                (touchend)="OnTouchEnd()"
                (touchcancel)="OnTouchEnd()"
            >
                <ion-button uppDataid="timemodal-hour-increment" fill="clear" class="unit-btn" (click)="IncrementHour()">
                    <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
                </ion-button>

                <ion-input uppDataid="timemodal-hour-input"
                    [value]="hourText"
                    class="unit-input"
                    inputmode="numeric"
                    maxlength="2"
                    autocomplete="off"
                    (ionInput)="OnHourInput($event)"
                    (ionBlur)="OnHourBlur()"
                ></ion-input>

                <ion-button uppDataid="timemodal-hour-decrement" fill="clear" class="unit-btn" (click)="DecrementHour()">
                    <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
                </ion-button>
            </div>

            <div class="time-separator">:</div>

            <div
                class="time-unit"
                (touchstart)="OnTouchStart('minute', $event)"
                (touchmove)="OnTouchMove('minute', $event)"
                (touchend)="OnTouchEnd()"
                (touchcancel)="OnTouchEnd()"
            >
                <ion-button uppDataid="timemodal-minute-increment" fill="clear" class="unit-btn" (click)="IncrementMinute()">
                    <ion-icon slot="icon-only" name="chevron-up-outline"></ion-icon>
                </ion-button>

                <ion-input uppDataid="timemodal-minute-input"
                    [value]="minuteText"
                    class="unit-input"
                    inputmode="numeric"
                    maxlength="2"
                    autocomplete="off"
                    (ionInput)="OnMinuteInput($event)"
                    (ionBlur)="OnMinuteBlur()"
                ></ion-input>

                <ion-button uppDataid="timemodal-minute-decrement" fill="clear" class="unit-btn" (click)="DecrementMinute()">
                    <ion-icon slot="icon-only" name="chevron-down-outline"></ion-icon>
                </ion-button>
            </div>
        </div>
    </div>
</ion-content>
